import { AxiosResponse } from 'axios';
import api from '../../../services/api';
import { UserInterface } from '@e3labs/isa-data-dictionary';

class DailyRouteService {
  getAllDailyRoute(
    {
      isCount = false,
      userExternalCodes = []
    }: {
      isCount?: boolean;
      userExternalCodes?: string[];
    },
    opts?: any
  ): Promise<AxiosResponse<any>> {
    return api.get('/vendor-client-visit/route-config', {
      params: {
        isCount,
        userExternalCodes
      },
      ...opts
    });
  }
  getDailyVisit(id: string) {
    return api.get(`/vendor-client-visit/route-config/${id}`);
  }
  deleteDailyVisit(id: string) {
    return api.delete(`/vendor-client-visit/route-config/${id}`);
  }
  createDailyVisit(payload: any): Promise<AxiosResponse<any | null>> {
    return api.post('/vendor-client-visit/route-config', payload);
  }
  editDailyVisit(payload: any): Promise<AxiosResponse<any | null>> {
    return api.put(`/vendor-client-visit/route-config/${payload._id}`, payload);
  }

  getSellers(opts?: any): Promise<AxiosResponse<UserInterface[] | null>> {
    return api.get('/user', {
      params: {},
      ...opts
    });
  }
}

export default new DailyRouteService();
